import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=124fd890&scoped=true"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=124fd890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fd890",
  null
  
)

export default component.exports